import { assertNever } from '@kofno/piper';
import ReactionComponent, { RCProps } from '../../../../ReactionComponent';
import ParticipantsV2Store from '.';
import { load } from './Load';
import { State } from './Types';

interface Props extends RCProps<ParticipantsV2Store> {}

class ParticipantsV2Reactions extends ReactionComponent<ParticipantsV2Store, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'loading':
        load(store, state.query);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ParticipantsV2Reactions;
